window.pagePreloader = {
  element: document.querySelector('.page-preloader'),

  fadeOut(speed = 500, delay = 200) {
    this.element.style.transition = `opacity ${speed}ms ease ${delay}ms`;
    this.element.style.opacity = 0;

    window.setTimeout(() => {
      this.hide();
    }, speed + delay);
  },

  show() {
    this.element.style.display = 'block';
  },

  hide() {
    this.element.style.display = 'none';
  }
};

window.pagePreloader.show();